(function () {
    'use strict';

    angular
        .module('sodCommon')
        .factory('action-load-enums', actionFunc);

    function actionFunc(RmsEnum, lodash) {
        return function(options) {
            var enum_names = lodash.get(options, 'names', null);
            if (enum_names === null) return true;
            if (!(enum_names instanceof Array)) {
                enum_names = [enum_names];
            }

            enum_names.map(function(enum_name) {
               RmsEnum.load(enum_name);
            });

            return true;
        };
    }
})();
